module.exports = __webpack_public_path__ + "img/PT921.03d7303f.png";